import React, { useState } from 'react';
import './Gallery.css';
import gl3 from '../../Assets/gl3.jpg';
import gl1 from '../../Assets/gl1.jpg';
import gl2 from '../../Assets/gl2.jpg';
import gl4 from '../../Assets/gl4.jpg';
import gl5 from '../../Assets/gl5.jpg';
import gl7 from '../../Assets/gl7.JPG';
import gl9 from '../../Assets/gl9.JPG';
import gl14 from '../../Assets/gl14.JPG';


const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('photos');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [galleryPage, setGalleryPage] = useState(0);

  const ITEMS_PER_PAGE = 8;

  // Your existing photos
  const photos = [
    { src: gl3, title: 'Gallery Image 1', description: 'Team Event' },
    { src: gl1, title: 'Gallery Image 2', description: 'Team event' },
    { src: gl4, title: 'Gallery Image 3', description: 'Team event' },
    { src: gl5, title: 'Gallery Image 4', description: 'Team event' },
    { src: gl2, title: 'Gallery Image 5', description: 'Team event' },
    { src: gl7, title: 'Gallery Image 6', description: 'Client Visit' },
    { src: gl9, title: 'Gallery Image 7', description: 'Client Visit' },
    { src: gl14, title: 'Gallery Image 8', description: 'Client Visit' },
    // { src: gl14, title: 'Gallery Image 9', description: 'Achievement' },
    // { src: gl14, title: 'Gallery Image 10', description: 'Achievement' },
    // { src: gl14, title: 'Gallery Image 11', description: 'Achievement' },
  ];

  // Add your video sources here
  const videos = [
    // { 
    //   src: 'https://cdn.pixabay.com/video/2024/05/13/211603_large.mp4', 
    //   title: 'Company Video 1', 
    //   description: 'Product showcase' 
    // },
    // { 
    //   src: 'https://cdn.pixabay.com/video/2024/01/08/196068-902445699_large.mp4', 
    //   title: 'Company Video 2', 
    //   description: 'Behind the scenes' 
    // }
  ];

  const currentMedia = activeFilter === 'photos' ? photos : videos;
  const totalPages = Math.ceil(currentMedia.length / ITEMS_PER_PAGE);
  const startIndex = galleryPage * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedItems = currentMedia.slice(startIndex, endIndex);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    setCurrentIndex(0);
    setGalleryPage(0);
  };

  const nextGalleryPage = () => {
    if (galleryPage < totalPages - 1) {
      setGalleryPage(prev => prev + 1);
    }
  };

  const prevGalleryPage = () => {
    if (galleryPage > 0) {
      setGalleryPage(prev => prev - 1);
    }
  };

  const openLightbox = (displayIndex) => {
    const actualIndex = startIndex + displayIndex;
    setCurrentIndex(actualIndex);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % currentMedia.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      (prevIndex - 1 + currentMedia.length) % currentMedia.length
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    } else if (e.key === 'ArrowLeft') {
      prevSlide();
    }
  };

  React.useEffect(() => {
    if (lightboxOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [lightboxOpen, currentIndex]);

  return (

      <div className='gallery-screen'>
        <div className="gallery-header">
          <h1>Our Gallery</h1>
          <p className="subtitle">Explore our visual journey through moments that matter</p>
        </div>

        <div className="filter-container">
          <button 
            className={`filter-btn ${activeFilter === 'photos' ? 'active' : ''}`}
            onClick={() => handleFilterClick('photos')}
          >
            Photos
          </button>
          <button 
            className={`filter-btn ${activeFilter === 'videos' ? 'active' : ''}`}
            onClick={() => handleFilterClick('videos')}
          >
            Videos
          </button>
        </div>

        <div className="gallery-wrapper">
          {totalPages > 1 && galleryPage > 0 && (
            <button className="gallery-nav-btn prev-gallery-btn" onClick={prevGalleryPage}>
              &#10094;
            </button>
          )}

          <div className="gallery-grid">
            {displayedItems.map((item, index) => (
              <div 
                key={startIndex + index} 
                className="gallery-item"
                onClick={() => openLightbox(index)}
              >
                {activeFilter === 'photos' ? (
                  <img src={item.src} alt={item.title} />
                ) : (
                  <video src={item.src} muted loop playsInline />
                )}
                {/* <div className="media-type-badge">{activeFilter.slice(0, -1)}</div> */}
                <div className="overlay">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && galleryPage < totalPages - 1 && (
            <button className="gallery-nav-btn next-gallery-btn" onClick={nextGalleryPage}>
              &#10095;
            </button>
          )}
        </div>

        {totalPages > 1 && (
          <div className="gallery-pagination">
            <span className="page-indicator">
              Page {galleryPage + 1} of {totalPages}
            </span>
            <div className="page-dots">
              {Array.from({ length: totalPages }).map((_, index) => (
                <span 
                  key={index}
                  className={`dot ${galleryPage === index ? 'active' : ''}`}
                  onClick={() => setGalleryPage(index)}
                />
              ))}
            </div>
          </div>
        )}

        {lightboxOpen && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeLightbox}>×</button>
              
              <button className="prev-btn" onClick={prevSlide}>
                &#10094;
              </button>

              <div className="slide">
                {activeFilter === 'photos' ? (
                  <img 
                    src={currentMedia[currentIndex].src} 
                    alt={currentMedia[currentIndex].title} 
                  />
                ) : (
                  <video 
                    src={currentMedia[currentIndex].src} 
                    controls 
                    autoPlay 
                  />
                )}
              </div>

              <button className="next-btn" onClick={nextSlide}>
                &#10095;
              </button>

              <div className="lightbox-info">
                <h3>{currentMedia[currentIndex].title}</h3>
                <p>{currentMedia[currentIndex].description}</p>
                <span className="slide-counter">
                  {currentIndex + 1} / {currentMedia.length}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    
  );
};

export default Gallery;